/*
 * Copyright (c) 2022. CodeGen International (Pvt) Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of CodeGen
 * International (Pvt) Ltd. ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in accordance with the
 * terms of the license agreement you entered into with CodeGen International.
 */
import * as tslib_1 from "tslib";
import { EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { TcApiError } from '@tc-core/model/it/codegen/tbx/ext/errors/tc-api-error';
import { TcErrorType } from '@tc-core/model/it/codegen/tbx/ext/errors/tc-error';
import { TcHttpError } from '@tc-core/model/it/codegen/tbx/ext/errors/tc-http-error';
import { DialogModel, LEVEL } from '@tc-core/model/it/codegen/ui/framework/dialog-model';
import { TC } from '@tc-core/util/constants';
import { ConfigLoader } from '@tc-core/util/framework/config-loader.service';
import { EventManager } from '@tc-core/util/framework/event-manager.service';
import { UserJourneyManager } from '@tc-core/util/framework/user-journey-manager.service';
import { CommonHelper } from '@tc-core/util/helpers/common-helper.service';
import { SpinnerService } from '@tc-core/util/ui/spinner.service';
import { DialogService } from '@tc/dialog/dialog.service';
import { Subscription } from 'rxjs';
import { TCO } from '../../constants';
import { ResourceTypeSearchCriteria } from '../../models/criteria/resource-type-search-criteria';
import { AllocationFeature } from '../../models/reservation-v2/allocation-feature';
import { AllocationFeatureSearchCriteria } from '../../models/reservation-v2/criteria/allocation-feature-search-criteria';
import { ReservationV2ManagementService } from '../../services/backend-consumers/reservation-v2/reservation-v2-management.service';
import { ResourceTypeService } from '../../services/backend-consumers/setups/resource-type.service';
import { DMCCommon } from '../../services/util/common/dmc-common';
import { DataKey, DataStoreService } from '../../services/util/framework/data-store.service';
import { ResponseUtil } from '../../services/util/response/response-util.service';
import { DMCLocalStorageService, LocalDataKey } from '../../services/util/system/dmc-local-storage.service';
import { ContentSummaryCardService } from '../../services/util/ui/content-summary-card.service';
var AllocationFeatureComponent = /** @class */ (function () {
    function AllocationFeatureComponent(userJourneyManager, em, dataStore, spinnerService, reservationV2ManagementService, dialogService, commonHelper, localStorage, common, configLoader, summaryCardService, resourceTypeService) {
        this.userJourneyManager = userJourneyManager;
        this.em = em;
        this.dataStore = dataStore;
        this.spinnerService = spinnerService;
        this.reservationV2ManagementService = reservationV2ManagementService;
        this.dialogService = dialogService;
        this.commonHelper = commonHelper;
        this.localStorage = localStorage;
        this.common = common;
        this.configLoader = configLoader;
        this.summaryCardService = summaryCardService;
        this.resourceTypeService = resourceTypeService;
        this.featureSearchResultsSubscription = new Subscription();
        this.createFeatureObserver = new Subscription();
        this.allocationFeatureSearchResults = [];
        this.featureShowing = [];
        this.allocationFeatureSearchCriteria = new AllocationFeatureSearchCriteria();
        this.disabled = false;
        this.max = 10;
        this.min = 0;
        this.step = 1;
        this.thumbLabel = true;
        this.vertical = false;
        this.tickInterval = 1;
        this.isEnableSaveButton = false;
        this.isEnableDeleteButton = true;
        this.serviceTypeList = [];
        this.filteredServiceTypeList = [];
        this.expandedPanelIndex = -1;
        this.allResourceType = {
            code: 'All',
            isChecked: false,
            isShow: true,
            name: 'All',
            profileTypes: [],
            resourceCategory: ''
        };
        this.select = new EventEmitter();
        this.cardScroll = new EventEmitter();
    }
    AllocationFeatureComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.allocationFeatureConfig = this.configLoader.configurations.get(TCO.CONF.CONF_ALLOCATION_FEATURE_CONFIG);
        this.subscribeAllocationFeatureCriteria();
        this.getAllocationFeatures();
        this.getServiceType();
        this.em.addEvent(TC.CONF.CONF_EVENT_MANAGER, 'ADD_FEATURES').subscribe(function (e) {
            _this.featureShowing.push(new AllocationFeature());
        });
        this.userJourneyManager.canProceed.next(true);
    };
    /**
     * On each and every change event of an input this getting triggered.
     */
    AllocationFeatureComponent.prototype.onInputChange = function (event, type, allocationFeature, option) {
        switch (type) {
            case 'cost':
                allocationFeature.cost = event.value;
                if (allocationFeature.isServiceTypeValid) {
                    this.isEnableSaveButton = true;
                }
                break;
            case 'grade':
                allocationFeature.grade = event.value;
                if (allocationFeature.isServiceTypeValid) {
                    this.isEnableSaveButton = true;
                }
                break;
            case 'preference':
                allocationFeature.preference = event.value;
                if (allocationFeature.isServiceTypeValid) {
                    this.isEnableSaveButton = true;
                }
                break;
            case 'alphabetical order':
                allocationFeature.alphabeticalOrder = event.value;
                if (allocationFeature.isServiceTypeValid) {
                    this.isEnableSaveButton = true;
                }
                break;
            case 'serviceType':
                allocationFeature.serviceTypeName = option.name;
                break;
            default:
                break;
        }
    };
    AllocationFeatureComponent.prototype.subscribeAllocationFeatureCriteria = function () {
        var _this = this;
        this.featureSearchResultsSubscription = this.dataStore.get(DataKey.allocationFeatureSearchCriteria, true)
            .subscribe(function (data) {
            if (data) {
                _this.allocationFeatureSearchCriteria = data;
                _this.featureShowing = [];
            }
        });
    };
    /**
     * Retrieve all the saved allocation features
     */
    AllocationFeatureComponent.prototype.getAllocationFeatures = function () {
        var _this = this;
        this.reservationV2ManagementService.searchFeatureItems(this.allocationFeatureSearchCriteria)
            .subscribe(function (data) {
            var _a;
            if (data) {
                _this.featureShowing = [];
                _this.allocationFeatureSearchResults = ResponseUtil.getDataArray(data);
                (_a = _this.featureShowing).push.apply(_a, tslib_1.__spread(_this.allocationFeatureSearchResults));
            }
        });
    };
    AllocationFeatureComponent.prototype.saveAllocationFeature = function (allocationFeature) {
        var _this = this;
        this.dataStore.set(DataKey.saveAllocationFeature, null, true);
        this.createAllocationFeatureObserver();
        this.setAllocationFeature(allocationFeature);
        this.spinnerService.show();
        this.reservationV2ManagementService.saveAllocationFeature(allocationFeature)
            .subscribe(function (result) {
            if (result.status.code === TC.ErrorCodes.SUCCESS) {
                _this.getAllocationFeatures();
            }
        }, function (error) {
            _this.common.showSnackBar(error, 3000, TcErrorType.TYPE.ERROR);
        }, function () {
            _this.spinnerService.hide();
        });
    };
    AllocationFeatureComponent.prototype.deleteAllocationFeature = function (allocationFeature) {
        var _this = this;
        this.dataStore.set(DataKey.saveAllocationFeature, null, true);
        this.createAllocationFeatureObserver();
        this.spinnerService.show();
        this.reservationV2ManagementService.deleteAllocationFeature(allocationFeature.serviceType)
            .subscribe(function (result) {
            if (result.status.code === TC.ErrorCodes.SUCCESS) {
                _this.getAllocationFeatures();
            }
        }, function (error) {
            _this.common.showSnackBar(error, 3000, TcErrorType.TYPE.ERROR);
        }, function () {
            _this.spinnerService.hide();
        });
    };
    /**
     * Set default values as 0.
     */
    AllocationFeatureComponent.prototype.setAllocationFeature = function (allocationFeature) {
        if (allocationFeature.cost == null) {
            allocationFeature.cost = 0;
        }
        if (allocationFeature.grade == null) {
            allocationFeature.grade = 0;
        }
        if (allocationFeature.preference == null) {
            allocationFeature.preference = 0;
        }
        if (allocationFeature.alphabeticalOrder == null) {
            allocationFeature.alphabeticalOrder = 0;
        }
    };
    AllocationFeatureComponent.prototype.createAllocationFeatureObserver = function () {
        var _this = this;
        this.createFeatureObserver = this.dataStore.get(DataKey.saveAllocationFeature, true).subscribe(function (result) {
            if (_this.commonHelper.dataValidity(result)) {
                _this.createFeatureObserver.unsubscribe();
                _this.spinnerService.hide();
                _this.dataStore.set(DataKey.saveAllocationFeature, null, true);
                if (result.status.code === TC.ErrorCodes.SUCCESS) {
                    _this.isEnableSaveButton = false;
                    _this.localStorage.delete(LocalDataKey.unSavedFeature);
                    _this.common.showSnackBar('Auto Allocation Feature Saved Successfully.', 3000, TcErrorType.TYPE.INFO);
                }
                else {
                    var confirmError = new DialogModel(true, LEVEL.ERROR, 'Failed', 'Failed to Save the Auto Allocation Feature Details', true, 2000);
                    _this.dialogService
                        .confirm(confirmError)
                        .subscribe(function (res) {
                        if (res === true) {
                            console.log('true');
                        }
                    });
                }
            }
            else if (result instanceof TcApiError) {
                _this.spinnerService.hide();
            }
            else if (result instanceof TcHttpError) {
                _this.spinnerService.hide();
            }
        });
    };
    AllocationFeatureComponent.prototype.getServiceType = function () {
        var _this = this;
        this.dataStore.get(DataKey.resourceTypes).subscribe(function (types) {
            if (types) {
                _this.serviceTypeList = types;
                _this.serviceTypeList.push(_this.allResourceType);
                _this.filteredServiceTypeList = _this.serviceTypeList;
            }
        });
    };
    AllocationFeatureComponent.prototype.displayServiceTypeFn = function (serviceType) {
        return serviceType && serviceType.name ? serviceType.name : serviceType;
    };
    AllocationFeatureComponent.prototype.onServiceTypeFocus = function () {
        this.filteredServiceTypeList = [];
    };
    AllocationFeatureComponent.prototype.filterServiceTypes = function (input) {
        var _this = this;
        var resourceTypeSearchCriteria = new ResourceTypeSearchCriteria();
        resourceTypeSearchCriteria.name = input;
        this.resourceTypeService.getResourceTypes(resourceTypeSearchCriteria).subscribe(function (data) {
            _this.filteredServiceTypeList = ResponseUtil.getDataArray(data);
            if ('all'.search(input.toLowerCase()) > -1) {
                _this.filteredServiceTypeList.push(_this.allResourceType);
            }
        });
        var filteredFeatures = this.featureShowing.filter(function (feature) { return feature.serviceType.search(input) > -1; });
        var filteredFeature;
        if (filteredFeatures) {
            filteredFeature = filteredFeatures[0];
            var serviceTypesLength = filteredFeature.length;
            if (serviceTypesLength > 1) {
                filteredFeature.serviceTypeError = 'Service type is already exists';
                this.isEnableSaveButton = false;
                this.isEnableDeleteButton = false;
            }
            else {
                filteredFeature.isServiceTypeValid = true;
                this.isEnableSaveButton = true;
                this.isEnableDeleteButton = true;
            }
        }
    };
    AllocationFeatureComponent.prototype.onSelection = function (summaryCardData, index) {
        this.selectedSummary = summaryCardData;
        if (summaryCardData) {
            this.select.emit(summaryCardData);
            this.cardScroll.emit(index);
        }
    };
    AllocationFeatureComponent.prototype.getSummaryCardData = function (feature) {
        var contentCardList = this.summaryCardService.getContentCardsByConfig(this.allocationFeatureConfig, [feature]);
        return contentCardList[0];
    };
    AllocationFeatureComponent.prototype.onHeaderClick = function () {
        this.selectedSummary = null;
    };
    AllocationFeatureComponent.prototype.ngOnDestroy = function () {
        if (this.featureSearchResultsSubscription) {
            this.featureSearchResultsSubscription.unsubscribe();
        }
        if (this.createFeatureObserver) {
            this.createFeatureObserver.unsubscribe();
        }
    };
    return AllocationFeatureComponent;
}());
export { AllocationFeatureComponent };
